/** Cores das operadoras vindas do design (Claro em vermelho, Vivo em roxo). */
export function operatorPill(code: string | undefined): string {
  if (code === 'claro') return 'bg-[#FBEAE6] text-[#B3301B]';
  if (code === 'vivo') return 'bg-[#F3E9FB] text-[#6B21A8]';
  return 'bg-surface-200 text-ink-600';
}

/** A mesma cor da pílula, sólida — para o pontinho dos cards do dashboard. */
export function operatorDot(code: string | undefined): string {
  if (code === 'claro') return 'bg-[#B3301B]';
  if (code === 'vivo') return 'bg-[#6B21A8]';
  return 'bg-ink-400';
}
